import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import ToolRow from "./ToolRow";
import type { MCPConnectionTool } from "../../../services/agent-tools-service";
import { useTranslation } from "react-i18next";

type Props = {
  title: string;
  tools: MCPConnectionTool[];
  onToolChangeAccess: (tool: MCPConnectionTool) => void;
  defaultOpen?: boolean;
};

const ToolGroup = ({
  title,
  tools,
  onToolChangeAccess,
  defaultOpen = false,
}: Props) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(defaultOpen);
  const ChevronIcon = open ? ChevronDown : ChevronRight;

  return (
    <div className="border-t border-border first:border-t-0">
      <div className="flex items-center justify-between gap-3 py-4">
        <button
          type="button"
          onClick={() => setOpen((value) => !value)}
          className="flex items-center gap-2 text-sm font-medium text-foreground"
          aria-expanded={open}
        >
          <ChevronIcon
            className={`size-4 text-muted-foreground ${i18n.dir() === "rtl" && !open ? "rotate-180" : ""}`}
          />
          <span>{title}</span>
          <span className="rounded-full bg-muted px-2 py-0.5 text-xs text-muted-foreground">
            {tools.length}
          </span>
        </button>
      </div>

      {open && tools.length > 0 && (
        <div className="divide-y divide-border pb-2">
          {tools.map((tool) => (
            <ToolRow
              key={tool.id}
              tool={tool}
              onChangeAccess={onToolChangeAccess}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ToolGroup;
